import { ViewOptionContextProvider, createUseViewOptions } from "@poscon/shared-frontend";
import type { EramView } from "types/eramView";
import type { ViewOptionState } from "~redux/slices/viewOptionSlice";

export { ViewOptionContextProvider };

export const useViewOptions = createUseViewOptions<EramView, ViewOptionState>();
